import $foreign from "./foreign.cjs";
var unsafeUnionFn = $foreign.unsafeUnionFn;
export { unsafeUnionFn };
